import React, { forwardRef, useCallback, useState } from 'react';
import GenericMappingForm from '../GenericMappingForm';
import { FieldTypes } from 'utils/formUtils';
import { Form } from 'antd';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import message from 'components/CustomMessage';
import _ from 'lodash';

export const formatOSName = (names) => {
  const specialOSCases = {
    IOS: 'iOS',
    MACOS: 'MacOS'
  };
  return names?.split(',').map(name => specialOSCases[name.trim()] || _.capitalize(name.trim())).join(', ');
};

const CortexMappingForm = forwardRef(function CortexMappingForm(props, ref) {

  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();

  const fetchOS = useCallback(
    (params) => {
      let { promise, cancel } =
        ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
          login_id: props.loginConfigId,
          ...params,
        });
      promise
        .then((response) => response.projects)
        .catch(() => {
          message.error("Problem fetching operating systems");
        })
        .finally(() => setLoading(false));
      promise = promise.then((res) => {
        const formattedResponse = res.projects.map((os) => ({
          ...os,
          name: formatOSName(os.name)
        }))
        return formattedResponse;
    });
      return { promise, cancel };
    },
    [props.loginConfigId, props.toolName]
  );

  const extraFields = [{
    name: "operatingSystem",
    label: "Operating System",
    type: FieldTypes.MULTI_SELECT,
    loading,
    colSpan: 12,
    props: {
      api: fetchOS
    }
  }];

  const getExtraFieldsData = (config) => {
    const { operatingSystem } = config;
    return {
      operatingSystem: operatingSystem ? operatingSystem.join() : undefined
    };
  };

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { operatingSystem } = config;
    return {
      operatingSystem: operatingSystem ? operatingSystem.split(",") : undefined
    };
  }, []);

  return (
    <GenericMappingForm
      ref={ref}
      form={form}
      extraFields={extraFields}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  )
})

export default CortexMappingForm;